module.exports = __webpack_public_path__ + "img/kitkitimg1@4x.dee7b3ae.png";